// v-opacity="{background:'#fff', opacity: 0.32}"
const opacity = {
  inserted: function(el, binding) {
    // 如果容器为设置position属性，默认为 position = 'relative'
    // console.log(el.style.position, 'el.style.position')
    if (el.style.position === "static" || !el.style.position) {
      el.style.position = "relative";
    }
    var newNode = document.createElement("div");
    newNode.style.position = "absolute";
    newNode.style.left = '0';
    newNode.style.right = '0';
    newNode.style.top = '0';
    newNode.style.bottom = '0';
    newNode.style.margin = "auto";
    newNode.style.background =
      binding.value && binding.value.background
        ? binding.value.background
        : "#000";
    newNode.style.opacity =
      binding.value && binding.value.opacity ? binding.value.opacity : 0;
    if (el.children.length) {
      el.children[0].style.position = 'relative'
    }
    el.insertAdjacentElement('afterbegin', newNode)
  }
};

export default opacity;
